module.exports = __webpack_public_path__ + "static/media/Fabrika-rodjendan-pozivnica.9a0a45cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fabrika-zabave/Fabrika-rodjendan-pozivnica.jpg
// module id = 406
// module chunks = 0